import React from "react";

const group1 = [
  "Sent",
  "Not Sent",
  "In Progress",
  "In Review",
  "In Remediation (Purchaser)",
  "In Remediation (Vendor)",
  "Complete"
];

const group1ColorMap = {
  "Sent": { bg: "bg-blue-400", ring: "bg-blue-400/10" },
  "Not Sent": { bg: "bg-gray-400", ring: "bg-gray-400/10" },
  "In Progress": { bg: "bg-yellow-400", ring: "bg-yellow-400/10" },
  "In Review": { bg: "bg-purple-500", ring: "bg-purple-400/10" },
  "In Remediation (Purchaser)": { bg: "bg-red-500", ring: "bg-red-400/10" },
  "In Remediation (Vendor)": { bg: "bg-orange-400", ring: "bg-orange-400/10" },
  "Complete": { bg: "bg-green-400", ring: "bg-green-400/10" }
};

const blueStatuses = ["Pending Diligent Review"];
const greenStatuses = ["Final Report Delivered"];
const redStatuses = ["Cancelled", "Canceled Assessment"];
const yellowStatuses = [
  "Request Accepted",
  "Intro Email Sent",
  "Intro Meeting Complete",
  "Planning Meeting Complete",
  "Auditor Assigned",
  "Assessment Scheduled",
  "Assessment in Progress",
  "Assessment Complete",
  "Draft Review by Client",
  "Pending",
  "Draft Report Delivered",
  "Sponsor Draft Report Available",
  "Report Anonymized"
];

const StatusIndicator = ({ status }) => {
  const trimmed =
    typeof status === "string" ? status.trim() : status;
  const isEmpty =
    trimmed == null || trimmed === "";

  let bg = "bg-green-400";
  let ring = "bg-green-400/10";
  let label = isEmpty ? "--" : status;

  if (isEmpty) {
    bg = "bg-gray-400";
    ring = "bg-gray-400/10";
  } else if (group1.includes(status)) {
    bg = group1ColorMap[status].bg;
    ring = group1ColorMap[status].ring;
  } else if (blueStatuses.includes(status)) {
    bg = "bg-blue-400";
    ring = "bg-blue-400/10";
  } else if (greenStatuses.includes(status)) {
    bg = "bg-green-400";
    ring = "bg-green-400/10";
  } else if (redStatuses.includes(status) || status === "Cancelled") {
    bg = "bg-red-400";
    ring = "bg-red-400/10";
  } else if (yellowStatuses.includes(status)) {
    bg = "bg-yellow-400";
    ring = "bg-yellow-400/10";
  } else if (typeof status === "string" && status.toLowerCase().includes("not sent")) {
    bg = "bg-gray-400";
    ring = "bg-gray-400/10";
  } else if (status === "Archived") {
    bg = "bg-slate-400";
    ring = "bg-slate-400/10";
  }

  return (
    <div className="flex items-center">
      <div className={`flex-none rounded-full ${ring} p-1 mr-2`}>
        <div className={`h-2 w-2 rounded-full ${bg}`}></div>
      </div>
      <div className="ml-2 text-sm text-gray-700">{label}</div>
    </div>
  );
};

export default StatusIndicator;
